'use strict';

namespace Core {

    class HotelList {

        public hotels :any;
        public hotelImageIndex :number = 0;
        public hotelImages : any[] = [];
        public ready :boolean = false;
        public showHotelImages :boolean = false;
        public spinnerId :number = 0;

        private removeHotel: (event: any, hotel: any) => void;


        constructor( private $scope: any,
                     private imageService: any,
                     private urlUtils: any
        )
        {
            if (!this.hotels) {
                const watch = $scope.$watch('hl.hotels', (n, o) => {
                    if (n && n !== o) {
                        this.ready = true;
                        watch();
                    }
                });
            } else {
                this.ready = true;
            }
        }

        public selectHotel(hotel) {
            this.spinnerId = hotel.Id;
        }

        public openImageGallery(hotelId, photoCount, e) {
            e.preventDefault();

            const w = TRPCONFIG.DeviceSettings.HotelImageMaxWidth;
            const h = TRPCONFIG.DeviceSettings.HotelImageMaxHeight;

            this.hotelImageIndex = 0;
            this.hotelImages = [];
            for (let i = 0, l = photoCount; i < l; i++) {
                this.hotelImages.push({
                    src: this.imageService.getImageUrl(hotelId, w, h, i, false)
                });
            }
            this.showHotelImages = true;
        }

        public getHotelUrl(hotel) {
            return this.urlUtils.stripLeadingSlash(hotel.Url);
        }

    }

    angular
        .module('core')
        .directive('hotelList', (): ng.IDirective => {

        return {
            scope: {},
            controller: HotelList,
            controllerAs: 'hl',
            replace: true,
            bindToController: {
                hotels: '=',
                removeHotel: '&'
            },
            templateUrl: 'partials/home/directivetemplate?type=HotelList'
        };

    });

}
